export default [
  {
    path: '/reservation/events',
    name: 'reservation-events',
    component: () => import('@/views/pages/reservation/event/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.events',
      resource: 'reservation',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reservation/events/add',
    name: 'add-reservation-event',
    component: () => import('@/views/pages/reservation/event/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.events',
      resource: 'reservation',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reservation/events/modify/:id',
    name: 'modify-reservation-event',
    component: () => import('@/views/pages/reservation/event/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.events',
      resource: 'reservation',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
